import { Pipe, PipeTransform } from '@angular/core';
import { TableColumnStateService } from 'src/app/shared/global/dynamic-table/table-column-state.service';

@Pipe({
  name: 'columnData',
})
export class ColumnDataPipe implements PipeTransform {
  transform(tableColumns: any[], colName: string, pageName: string): any {
    const columnData = TableColumnStateService.getData(pageName);

    if (columnData) {
      tableColumns = tableColumns.map((column) => {
        const updatedColumn = columnData[column?.name];

        if (updatedColumn) return { ...column, ...updatedColumn };

        return column;
      });
    }
    const item = tableColumns?.find((c) => c.name === colName);
    return item;
  }
}
